var CalendarContainerCtrl = function(calendar, ModalService, resources) {
  this.calendarModel = calendar;
  this.resources = resources;
  this._ModalService = ModalService;
};

CalendarContainerCtrl.prototype.addAppointment = function() {
  this._ModalService.openAppointmentModal();
};

module.exports = CalendarContainerCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/calendar/CalendarContainerCtrl.js